// extracted by mini-css-extract-plugin
export default {"container":"style_container__6zAho","card":"style_card__LZpeX","row":"style_row__-tT10","btnsRow":"style_btnsRow__JWezF"};